import { get } from 'lodash';

import Product from 'models/Product';
import { MODAL_TYPES } from 'state/constants';
import { getProductData } from 'state/selectors/collection';
import Device from 'utils/Device';

const openStoryCardModalEvent = action => {
  const modalType = get(action, 'payload');
  const collectionHandle = get(action, ['meta', 'origination']);
  if (modalType === MODAL_TYPES.STORY_CARD) {
    return {
      hitType: 'event',
      eventCategory: 'collections',
      eventAction: 'clickStoryCard',
      eventLabel: collectionHandle,
    };
  }

  return null;
};

const setMasterProductCardProduct = (action, prevState, nextState) => {
  const { productHandle } = action.payload;

  const product = new Product(getProductData(nextState, productHandle));

  const eventAction = Device.isMediumUp ? 'thumbnailClick' : `swatchClick`;

  return {
    hitType: 'event',
    eventCategory: 'collections',
    eventAction,
    eventLabel: `${product.colorName} - ${product.masterName}`,
  };
};

const setMasterProductCardCarouselIndex = action => {
  const { masterHandle } = action.payload;

  return {
    hitType: 'event',
    eventCategory: 'collections',
    eventAction: `thumbnailScroll`,
    eventLabel: masterHandle,
  };
};

export { openStoryCardModalEvent, setMasterProductCardProduct, setMasterProductCardCarouselIndex };

export default openStoryCardModalEvent;
